import {
  getAllPeopleDetailsByName,
  getUserDetails,
  RequestToken,
} from '../../../core/authentication'

import { useMsal } from '@azure/msal-react'
// eslint-disable-next-line import/no-unresolved
import { User } from '@microsoft/microsoft-graph-types'
import { getUserEmail } from '../../utils/utils'

const usePeopleDetails = () => {
  const { instance, accounts } = useMsal()

  const getPeopleDetailsByName = async (nameQuery: string) => {
    if (nameQuery.trim() === '') {
      return []
    }

    try {
      const accessToken = await RequestToken(instance, accounts)
      if (accessToken) {
        const usernames = await getAllPeopleDetailsByName(
          nameQuery,
          accessToken
        )

        // Debug: Log search results to see if we get different users
        console.log(
          'Search results for:',
          nameQuery,
          usernames.map((u: User) => ({
            id: u.id,
            displayName: u.displayName,
            userPrincipalName: u.userPrincipalName,
            mail: u.mail,
          }))
        )

        const mappedOptions = usernames.map((user: User) => ({
          key: user.id,
          value: `${user.displayName}|||${user.id}`, // Make value unique by including ID
          label: user.displayName,
          displayName: user.displayName, // Keep original name for form display
          email: getUserEmail(user.userPrincipalName, user.mail),
          title: user.jobTitle,
          office: user.officeLocation,
        }))

        console.log('Mapped search options:', mappedOptions)

        return mappedOptions
      }
    } catch (error) {
      console.error('Error fetching usernames:', error)
      return []
    }
  }

  const getUserDetailsById = async (idQuery: string) => {
    if (idQuery === '') {
      return {}
    }

    try {
      const accessToken = await RequestToken(instance, accounts)
      if (accessToken) {
        const userdetails = await getUserDetails(
          'users/' + idQuery,
          accessToken
        )

        // Debug: Log email properties
        console.log('User email properties:', {
          userPrincipalName: userdetails.userPrincipalName,
          mail: userdetails.mail,
          displayName: userdetails.displayName,
          isExternalUser: userdetails.userPrincipalName?.includes('#EXT#'),
          selectedEmail: getUserEmail(
            userdetails.userPrincipalName,
            userdetails.mail
          ),
        })

        return userdetails
      }
    } catch (error) {
      console.error('Error fetching user details by user id:', error)
      return {}
    }
  }

  return { getPeopleDetailsByName, getUserDetailsById }
}
export default usePeopleDetails
